

import angular from 'angular';
var module = angular.module('pi.modal',[]);

module.service('piModal', modalService);
import modalService from './modalService';

export default module;
